import { Component, OnInit } from "@angular/core";

import { SubHeaderService } from "../services/sub-header.service";
import {SubHeader} from "../models/sub-header.model";

@Component({
    selector: "sub-header",
    templateUrl: "./sub-header.component.html",
    styleUrls: ["./sub-header.component.scss"],
    standalone: false
})
export class SubHeaderComponent implements OnInit {
    subHeader = new SubHeader({
        title: "Title"
  });
    get haveButtons(): boolean {
      if (this.subHeader.buttons) {
        return this.subHeader.buttons.length > 0;
      } else {
        return false;
      }
    }

    constructor( public subHeaderService: SubHeaderService ) { }

    ngOnInit() {
        this.subHeaderService.onSubHeaderChange().subscribe(results => {
            if (results.buttons) {
                results.buttons.forEach(b => {
                    if (!b.isDisabled || typeof (b.isDisabled) !== "function") {
                        b.disabled = () => { return false };
                    }
                });
            }
            this.subHeader = results;
        });

        this.subHeaderService.updateSubHeader(this.subHeader);
    }

    public invokeButton(button: any): void {
        //do some invoking here
        button.method();
    }
}